"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.switchNotExistingToUndefined = exports.extractFlatReferences = exports.extractReferences = exports.run = void 0;
var lodash_1 = __importStar(require("lodash"));
var formatters_1 = require("./formatters");
var types_1 = require("./types");
var moment_1 = __importDefault(require("moment"));
function run(c) {
    return function e(v) {
        if (Array.isArray(v)) {
            return v.map(e);
        }
        else if (v === null || v === undefined) {
            return v;
        }
        else if (typeof v === 'object') {
            if (types_1.isExpression(v)) {
                if (types_1.isReference(v)) {
                    return lodash_1.default.get(c, v.$, e(v.default));
                }
                else {
                    var $_1 = v.$;
                    switch ($_1.type) {
                        case 'each': {
                            var source = e($_1.in);
                            var as_1 = $_1.as || 'it';
                            return (Array.isArray(source) ? source : [source]).map(function (it) {
                                var _a;
                                return run(__assign(__assign({}, c), (_a = {}, _a[as_1] = it, _a)))($_1.return);
                            });
                        }
                        case 'if': {
                            if (e($_1.condition)) {
                                return e($_1.then);
                            }
                            else {
                                return $_1.otherwise ? e($_1.otherwise) : undefined;
                            }
                        }
                        case '==': {
                            return switchNotExistingToUndefined(e($_1.a)) === switchNotExistingToUndefined(e($_1.b));
                        }
                        case 'neq': {
                            var a = e($_1.a);
                            var b = e($_1.b);
                            return a !== b || (Number.isNaN(a) && Number.isNaN(b));
                        }
                        case '>': {
                            var a = e($_1.a);
                            var b = e($_1.b);
                            if (typeof a === 'number' && typeof b === 'number') {
                                return a > b;
                            }
                            else {
                                return false;
                            }
                        }
                        case 'in': {
                            var a = e($_1.a);
                            var b = e($_1.b);
                            return b.includes(a);
                        }
                        case 'and': {
                            for (var v_1 in $_1.values) {
                                if (!e($_1.values[v_1]))
                                    return false;
                            }
                            return true;
                        }
                        case 'or': {
                            for (var v_2 in $_1.values) {
                                if (e($_1.values[v_2]))
                                    return true;
                            }
                            return false;
                        }
                        case 'concat': {
                            return ''.concat.apply('', e($_1.values).map(function (v) { return e(v) || ''; }));
                        }
                        case 'format': {
                            return formatters_1.formatValue(e(v.$.value), v.$.formatter, c);
                        }
                        case 'length': {
                            return e($_1.values).length;
                        }
                        case 'join': {
                            return (e($_1.collection) || []).join($_1.joiner);
                        }
                        case 'now': {
                            return Date.now();
                        }
                        case 'sum': {
                            return lodash_1.default.sum(e($_1.values).map(function (v) { return Number(v) || 0; }));
                        }
                        case 'div': {
                            return e($_1.a) / e($_1.b);
                        }
                        case 'mul': {
                            return e($_1.a) * e($_1.b);
                        }
                        case 'get': {
                            return lodash_1.get(e($_1.value), e($_1.getter), e($_1.default));
                        }
                        case 'last': {
                            return lodash_1.default.last(e($_1.values));
                        }
                        case 'spread': {
                            return __assign(__assign({}, e($_1.value)), e($_1.updatedFields));
                        }
                        case 'find': {
                            return lodash_1.default.find(e($_1.in), function (v) {
                                var _a;
                                return run(__assign((_a = {}, _a[$_1.as] = v, _a), c))($_1.predicate);
                            });
                        }
                        case 'find-all': {
                            return e($_1.in).filter(function (v) {
                                var _a;
                                return run(__assign((_a = {}, _a[$_1.as] = v, _a), c))($_1.predicate);
                            });
                        }
                        case 'split': {
                            return e($_1.in).split($_1.splitBy);
                        }
                        case 'max-by': {
                            return lodash_1.maxBy(e($_1.in), function (v) {
                                var _a;
                                return run(__assign((_a = {}, _a[$_1.as] = v, _a), c))($_1.expression);
                            });
                        }
                        case 'date': {
                            // eslint-disable-next-line @typescript-eslint/no-unused-vars
                            var date = moment_1.default(e($_1.init));
                            return eval($_1.formula);
                        }
                    }
                }
            }
            else if (v.$$) {
                return function (context) { return run(context)(v.$$); };
            }
            else {
                return lodash_1.default.mapValues(v, e);
            }
        }
        else {
            return v;
        }
    };
}
exports.run = run;
function extractReferences(v, localVariables) {
    if (localVariables === void 0) { localVariables = []; }
    if (Array.isArray(v)) {
        return lodash_1.default.uniq(lodash_1.default.flatMap(v, function (x) { return extractReferences(x, localVariables); }));
    }
    else if (v === null || v === undefined) {
        return [];
    }
    else if (typeof v === 'object') {
        if (types_1.isExpression(v)) {
            if (types_1.isReference(v)) {
                if (localVariables.includes(types_1.baseRefName(v.$))) {
                    return [];
                }
                else {
                    return [v.$];
                }
            }
            else if (v.$.type === 'each') {
                return lodash_1.default.uniq(__spreadArrays(extractReferences(v.$.in, localVariables), extractReferences(v.$.return, __spreadArrays(localVariables, [v.$.as]))));
            }
        }
        else if (v.$$) {
            return [];
        }
        return lodash_1.default.uniq(lodash_1.default.flatMap(lodash_1.default.values(v), function (x) { return extractReferences(x, localVariables); }));
    }
    return [];
}
exports.extractReferences = extractReferences;
function extractFlatReferences(v) {
    return lodash_1.default.uniq(extractReferences(v).map(function (x) { return types_1.baseRefName(x); }));
}
exports.extractFlatReferences = extractFlatReferences;
function switchNotExistingToUndefined(value) {
    if (value === null)
        return undefined;
    return value;
}
exports.switchNotExistingToUndefined = switchNotExistingToUndefined;
//# sourceMappingURL=interpreter.js.map